import { render, staticRenderFns } from "./PoiSubHut.vue?vue&type=template&id=d372e1e6"
import script from "./PoiSubHut.js?vue&type=script&lang=js&external"
export * from "./PoiSubHut.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports